export const formatValuationParamsString = valueToFormat => {
  const val = String(valueToFormat)
  if (val === 'null' || val === 'undefined') {
    return 'N/A'
  } else {
    const ret = val
      .trim()
      .replaceAll(/.{1}/g, '$&, ')
      .trim()
      .replaceAll(',,', '')

    if (ret !== '') {
      return ret.slice(0, -1)
    } else {
      return 'N/A'
    }
  }
}
